import type { InMemoryAdditionalCompensation } from 'modules/contracts/lib/contractFlowContext'

const isSameAdditionalCompensation = (
  a: InMemoryAdditionalCompensation,
  b: InMemoryAdditionalCompensation
): boolean => {
  if (a.id && b.id) {
    return a.id === b.id
  }

  if (a.tmpID && b.tmpID) {
    return a.tmpID === b.tmpID
  }

  return false
}

const replaceAdditionalCompensationInList = (
  additionalCompensations: InMemoryAdditionalCompensation[],
  additionalCompensation: InMemoryAdditionalCompensation
) =>
  additionalCompensations.map((currentAdditionalCompensation) =>
    isSameAdditionalCompensation(currentAdditionalCompensation, additionalCompensation)
      ? { ...additionalCompensation }
      : currentAdditionalCompensation
  )

const removeAdditionalCompensationFromList = (
  additionalCompensations: InMemoryAdditionalCompensation[],
  additionalCompensation: InMemoryAdditionalCompensation
) =>
  additionalCompensations.filter(
    (currentAdditionalCompensation) =>
      !isSameAdditionalCompensation(currentAdditionalCompensation, additionalCompensation)
  )

export {
  isSameAdditionalCompensation,
  removeAdditionalCompensationFromList,
  replaceAdditionalCompensationInList,
}
